var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("vue-data-table", {
        attrs: {
          tableColumns: _vm.columns,
          tableRows: _vm.rows,
          isLoading: _vm.isLoading,
          showRowTableAction: false,
          "empty-rows-message": _vm.$t("components.table.no_data"),
        },
        on: _vm._d({}, [_vm.needDataUpdateEvent, _vm.init]),
        scopedSlots: _vm._u([
          {
            key: "table-row",
            fn: function (props) {
              return [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.showDetail(props.row.getRaw)
                      },
                    },
                  },
                  [_vm._v(_vm._s(props.cell.getValue))]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }